import { Box, CircularProgress } from '@mui/material'
import { FlexBoxProps, TokenAmount, useAsyncEffect } from '@xylabs/sdk-react'
import BigNumber from 'bn.js'
import { useContext, useState } from 'react'

import { DepositDialog, WithdrawDialog } from '../../Components'
import { EthersContext, useGeotoken } from '../../Contexts'
import { shiftBase10 } from '../../shiftBase10'
import { Property } from '../Property'

const BalanceProperty: React.FC<FlexBoxProps> = (props) => {
  const { localAddress } = useContext(EthersContext)
  const geotoken = useGeotoken()

  const [withdrawDialogOpen, setWithdrawDialogOpen] = useState(false)
  const [depositDialogOpen, setDepositDialogOpen] = useState(false)

  const onWithdrawErc20Click = () => {
    setWithdrawDialogOpen(true)
  }

  const onDepositErc20Click = () => {
    setDepositDialogOpen(true)
  }

  const [isOwner, setIsOwner] = useState<boolean | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const owner = await geotoken?.getOwner()
      const data = owner && localAddress && owner?.toHex() === localAddress?.toHex()
      if (!isMounted()) return
      setIsOwner(data)
    },
    [geotoken, localAddress],
  )

  const [balance, setBalance] = useState<BigNumber | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const data = await geotoken?.getBalance()
      if (isMounted()) {
        setBalance(data)
      }
    },
    [geotoken],
  )

  return (
    <Property
      actions={[
        { disabled: !isOwner, name: 'Deposit', onClick: onDepositErc20Click },
        { disabled: !isOwner, name: 'Withdraw', onClick: onWithdrawErc20Click },
      ]}
      title="Balance"
      value={shiftBase10(balance, -18)?.toString()}
      {...props}
    >
      <Box>
        {balance !== undefined ? <TokenAmount amount={balance} /> : <CircularProgress size={24} />}
        <WithdrawDialog onClose={() => setWithdrawDialogOpen(false)} open={withdrawDialogOpen} />
        <DepositDialog onClose={() => setDepositDialogOpen(false)} open={depositDialogOpen} />
      </Box>
    </Property>
  )
}

export default BalanceProperty
